import { MULTITABSINTURNO_LOGOUT, MULTITABSINTURNO_SETPASO, RESET_PORTAL_CONTEXT } from "../ActionTypes";

import multitabSinTurnoInitialState from "../initialStates/multitabSinTurnoInitialState";

const multitabSinTurno = (state, { payload, type }) => {
  switch (type) {
    case MULTITABSINTURNO_SETPASO:
      return {
        multitabSinTurno: {
          paso: payload,
        },
      };
    case MULTITABSINTURNO_LOGOUT:
      return multitabSinTurnoInitialState;
    case RESET_PORTAL_CONTEXT:
      return multitabSinTurnoInitialState;
    
    default:
      return state;
  }
};

export default multitabSinTurno;
